import { ClientDataType } from './ClientDataType';
import { SystemGroups } from './SystemGroups';

export const SHEDVIEW = 'shedview';
export const CARPORTVIEW = 'carportview';
export const IDEAROOM = 'idearoom';

export const IDEAROOM_CLIENT_ID = `${SystemGroups.IdeaRoom.toLowerCase()}-${ClientDataType.Reference}`;
